import { CarrierAppointmentsCSVInput } from "./interfaces";

export const headerMapping: { [key: string]: keyof CarrierAppointmentsCSVInput } = {
  "Producer First Name": "producerFirstName",
  "Producer Last Name": "producerLastName",
  NPN: "NPN",
  "Appointment state": "appointmentState",
  "Producer status": "producerStatus",
  "Carrier Legal Name": "carrierLegalName",
  "Carrier Brand Name": "carrierBrandName",
  HIOS: "HIOS",
  "NAIC Code": "NAICCode",
  "Line of Authority": "lineOfAuthority",
  "Line of Authority Status": "lineOfAuthorityStatus",
  "Appointment Status": "appointmentStatus",
  "Appointment Effective Date": "appointmentEffectiveDate",
  "Appointment Expiration Date": "appointmentExpirationDate",
  "Upline Agency": "uplineAgency",
  "Commission structure": "commissionStructure",
  "PMPM rate": "pmpmRate",
  Percent: "percent",
};

export const mapCSVDataToCarrierAppointments = (csvRecords: string[][]) => {
  const headers = csvRecords[0];
  const content = csvRecords.slice(1);

  const mappedData = content.map((row: string[]) => {
    return headers.reduce((obj: Partial<CarrierAppointmentsCSVInput>, header: string, index: number) => {
      const mappedKey = headerMapping[header];
      if (mappedKey) {
        // Handle numeric fields
        if (mappedKey === "pmpmRate" || mappedKey === "percent") {
          const value = row[index]?.trim();
          if (value) {
            (obj as any)[mappedKey] = Number(value);
          }
        } else {
          (obj as any)[mappedKey] = row[index];
        }
      }
      return obj;
    }, {});
  }) as CarrierAppointmentsCSVInput[];

  return mappedData;
};
